import Default from '../views/index/Default'
import Signin from '../views/index/Signin'
import Signup from '../views/index/Signup'
import Forget from '../views/index/Forget'
import ResetPwd from '../views/index/ResetPwd'
import OAuth from '../views/index/OAuth'
import UnsubscribeEmail from '../views/index/UnsubscribeEmail'

const routes = [
    {
        path: '/signin',
        name: '登录',
        component: Signin,
        layout: ''
    },
    {
        path: '/signup',
        name: '注册',
        component: Signup,
        layout: ''
    },
    {
        path: '/forget',
        name: '忘记密码',
        component: Forget,
        layout: ''
    },
    {
        path: '/reset',
        name: '重置密码',
        component: ResetPwd,
        layout: ''
    },
    {
        path: '/oauth',
        name: '第三方登录',
        component: OAuth,
        layout: ''
    },
    {
        path: '/unsubscribe',
        name: '邮件退订',
        component: UnsubscribeEmail,
        layout: ''
    },
    {
        path: '/',
        name: '主页',
        component: Default,
        layout: ''
    }
]

export default routes
